import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpContext } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { CommonFunction } from '../../app/helpers/commonFunction';
import { SKIP_LOADER } from '../interceptor/loader.interceptor';

@Injectable()
export class OrganisationChartService {
  private readonly skipLoaderContext = new HttpContext().set(SKIP_LOADER, true);

  constructor(
    private http: HttpClient,
    private httpWithoutToken: HttpClient,
    private handler: HttpBackend,
    private commonFunction: CommonFunction
  ) {
    this.httpWithoutToken = new HttpClient(handler);
  }

  

    getDirectorHierarchyData(): Promise<any> {
        return this.http.get(environment.clientUrl + "user/directorscompanyHierarchy", {
            context: this.skipLoaderContext,
        })
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    getManagementHierarchyData() {
        return this.http.get(environment.clientUrl + "user/execmanagementcompanyHierarchy", {
            context: this.skipLoaderContext,
        })
            .toPromise()
            .then((response: any) => {
                return Promise.resolve({response,companyHierarchy: JSON.parse(this.commonFunction.decrypt(response.companyHierarchy)) })
            })
    }

  getDiscloserOfInterestOfDirectors(directorsList): Promise<any> {
    return this.httpWithoutToken
      .post(
        environment.pssServerUrl + 'getDisclosureOfIneterstCount',
        directorsList,
        { context: this.skipLoaderContext }
      )
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      });
  }
}
